import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { AuthContextType } from "../../contexts/AuthContextType";

export const PrivateRoute = () => {
	const { currentUser } = useContext<AuthContextType>(AuthContext);
	return currentUser ? <Outlet /> : <Navigate to="/signin" />;
};
